import React from 'react';

import DynamicsDetailsForm from '../../forms/DynamicsDetailsForm';
import SalesforceDetailsForm from '../../forms/SalesforceDetailsForm';
import ServiceNowDetailsForm from '../../forms/ServiceNowDetailsForm';

export default function EditDialogContent({ formData, setFormData }) {
  switch (formData.type) {
    case 'dynamics':
      return (
        <DynamicsDetailsForm formData={formData} setFormData={setFormData} />
      );
    case 'salesforce':
      return (
        <SalesforceDetailsForm formData={formData} setFormData={setFormData} />
      );
    case 'servicenow':
      return (
        <ServiceNowDetailsForm formData={formData} setFormData={setFormData} />
      );
    default:
      return <div>Unknown environment type: ${formData.type}</div>;
  }
}
